import React from 'react';
import jwt from 'jsonwebtoken';


function getUser() {
    const user = JSON.parse(localStorage.getItem('user'));
    return user;
}

function setUser(user) {
    localStorage.setItem('user', JSON.stringify(user));
}

function getUserRoles() {
    const user = getUser();
    if (!user || !user.token)
        return;
    const token = user.token;
    const decoded = jwt.decode(token, {complete: true});
    const roles = decoded.payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
    return roles;
}

function checkUserExist() {
    const user = getUser();
    return user ? true : false;
}

function logout() {
    localStorage.clear();
    window.location.reload();
}

export {getUser, setUser, getUserRoles, checkUserExist, logout};
